import { Business } from 'src/model/Business';
import { SAFEGUARD_CONTRACT_BASE_URL } from 'src/constants/Links';

export const generateSafeguardUrl = (intakeId: string, business: Business): string => {
    const cityStateZip = `${business.city}, ${business.state} ${business.zipCode}`;
    
    const params = new URLSearchParams({
        TRANSACTION_ID: intakeId,
        W9_ADDRESS: business.streetAddress,
        CITY_STATE_ZIP: cityStateZip,
        PRIMARY_PHONE: business.phone,
        EMAIL: business.email
    });
    
    return `${SAFEGUARD_CONTRACT_BASE_URL}&${params.toString()}`;
};
